import { FC, useEffect, useRef, useState } from "react";
import { StatisticsObjectType } from "../caseVolume/types";
import { BAR_CHART_STIMROUTER } from "src/constants/highCharts";
import HighchartsReact from "highcharts-react-official";
import HighCharts from "highcharts";
import type { Options, SeriesBarOptions } from "highcharts";


const CustomComponentForPriorAuth: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const [barChartOptionPrior, setChartOptions] = useState(BAR_CHART_STIMROUTER);

  useEffect(() => {
    const received = Number(StatisticsObjectType?.cases_by_drug?.count) || 0;

    const updatedOptions: Options = {
      ...BAR_CHART_STIMROUTER,
      series: [
        {
          type: "bar",
          name: "Value",
          data: [received],
        } as SeriesBarOptions, // 👈 explicitly cast the type
      ],
    };
    setChartOptions(updatedOptions);
  }, [StatisticsObjectType]);

  return (
    <div className="card mt-3">
      <div className="card-header">
        <h5 className="m-0 text-center text-white">Cases By Drug</h5>
      </div>
      <div className="card-body">
        <HighchartsReact
          highcharts={HighCharts}
          options={barChartOptionPrior}
          immutable={true}
          ref={chartComponentRef}
        />
      </div>
    </div>
  );
};

export default CustomComponentForPriorAuth;
